<div class="table-responsive">
  <table id="{{tableId}}" class="table table-hover table-outline table-vcenter text-nowrap card-table">

  </table>
</div>
